// removed by extract-text-webpack-plugin
module.exports = {"main-layout":"main-layout"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/Layout/style.scss
// module id = 604
// module chunks = 0